module.exports = __webpack_public_path__ + "static/media/Deli-Doces-01.0cb0d1d7.jpg";